<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title">Shakespeare’s Other Son? William Davenant</h1>
<p class="subtitle">Playwright, Civil War Gun-Runner, and Restoration Theatre Manager</p>
<p class="author">R. E. Pritchard</p>
<div class="img_container1">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?0193e346